export const PackageLevelType = {
	Bronze: { Id: 1, CustomerPackageLevel: 0, Name: "Bronze" },
	Silver: { Id: 2, CustomerPackageLevel: 1, Name: "Silver" },
	Gold: { Id: 3, CustomerPackageLevel: 2, Name: "Gold" },
	Platinum: { Id: 4, CustomerPackageLevel: 3, Name: "Platinum" },
};
